import {
  ENTERPRISE_LOGIN_BG_POSTER_URL,
  ENTERPRISE_LOGIN_BG_VIDEO_URL,
  isEnterpriseDistribution,
  SITE,
} from '@/app/constants';
import { cn } from '@/app/utils';

// 非企业版用 Q4 主视觉视频（与 Q4 开屏弹窗、Q4 产品页同一份素材），按站点走各自 CDN。
const ASSET_ORIGIN = SITE === 'china' ? 'https://image01-aliyun.vidu.zone' : 'https://image01.cf.vidu.studio';
const LOGIN_VIDEO_URL = isEnterpriseDistribution
  ? ENTERPRISE_LOGIN_BG_VIDEO_URL
  : `${ASSET_ORIGIN}/vidu/media-asset/Q4-0110e797.mp4`;
const LOGIN_POSTER_URL = isEnterpriseDistribution
  ? ENTERPRISE_LOGIN_BG_POSTER_URL
  : `${ASSET_ORIGIN}/vidu/media-asset/Q4-c510a4f0.webp`;

/** 登录页 / 登录弹窗左侧的视频面板：圆角裁切、视频铺满。外层尺寸与留白由调用方决定。 */
export const LoginVideoPanel = ({ className }: { className?: string }) => (
  <div className={cn('relative overflow-hidden rounded-16', className)}>
    <video
      poster={LOGIN_POSTER_URL}
      muted
      autoPlay
      loop
      playsInline
      webkit-playsinline="true"
      x5-playsinline="true"
      className="absolute inset-0 h-full w-full object-cover"
    >
      <source src={LOGIN_VIDEO_URL} type="video/mp4" />
      <track kind="captions" />
    </video>
  </div>
);
